// Entry: fonts (self-hosted, no Google Fonts — CSP + LGPD), theme, i18n, query client, router; Sentry only if configured.
import '@fontsource/hanken-grotesk/400.css';
import '@fontsource/hanken-grotesk/600.css';
import '@fontsource/hanken-grotesk/700.css';
import '@fontsource/spline-sans-mono/400.css';
import './styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RootErrorBoundary } from './components/ErrorScreen.tsx';
import { i18nReady } from './i18n.ts';
import { initSentry } from './lib/sentry.ts';
import { makeRouter } from './router.tsx';

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 60_000, retry: 1 } } });
const router = makeRouter();

void initSentry();
void i18nReady.then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <RootErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </RootErrorBoundary>
    </StrictMode>,
  );
});
